module.exports = __webpack_public_path__ + "img/icon_search_white.67ce91e3.svg";